import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ServiceDocumentsApi } from '@vi-iot/client';

import { ErrorDetailsActions } from './error-details.actions';

@Injectable()
export class ErrorDetailsEffects {
  getErrorDetails$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(ErrorDetailsActions.getErrorDetails.attempt),
      switchMap((action) =>
        this.serviceDocumentsApi
          .listErrorsDatabase({
            materialNumber: action.materialNumber,
            errorCode: action.errorCode,
            countryCode: action.countryCode,
            languageCode: action.languageCode,
          })
          .pipe(
            map((errorsData) => {
              const index = errorsData?.faultCodes[0]?.faultCode?.indexOf(' ');
              const isLongErrorCodeName = index > 0;

              if (isLongErrorCodeName) {
                errorsData.faultCodes[0].faultCode = errorsData.faultCodes[0].faultCode.substring(
                  0,
                  index
                );
              }

              return ErrorDetailsActions.getErrorDetails.success({ existingErrors: errorsData });
            }),
            catchError((error) => of(ErrorDetailsActions.getErrorDetails.failed({ error })))
          )
      )
    );
  });

  getAllErrorsDetails$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(ErrorDetailsActions.getAllErrorsDetails.attempt),
      switchMap((action) =>
        this.serviceDocumentsApi
          .listErrorsDatabase({
            materialNumber: action.materialNumber,
            countryCode: action.countryCode,
            languageCode: action.languageCode,
          })
          .pipe(
            map((errors) => {
              if (
                errors.countryCode !== action.countryCode ||
                errors.languageCode !== action.languageCode
              ) {
                return ErrorDetailsActions.getAllErrorsDetails.aborted();
              }

              return ErrorDetailsActions.getAllErrorsDetails.success({ errors });
            }),
            catchError((error) => of(ErrorDetailsActions.getAllErrorsDetails.failed({ error })))
          )
      )
    );
  });

  constructor(private actions$: Actions, private serviceDocumentsApi: ServiceDocumentsApi) {}
}
